import { NavigationRoutes } from 'common/constants';
import {
  themedStyled,
  themedUseStyletron,
} from 'common/styles/styletron.theme';
import useNavigation from 'hooks/use-navigation';
import { MappedRoute } from 'hooks/use-search-menu';
import Link from 'next/link';
import * as React from 'react';

import { BeforeBorder, LinkContainer } from './styles';

interface Props {
  route: MappedRoute;
  depth: number;
}

export default function LinkComponent(props: Props) {
  const [, theme] = themedUseStyletron();
  const { route, depth } = props;
  const { navigate, activeKey } = useNavigation();

  const _onChange = React.useCallback(() => {
    !!route.itemId && navigate(route.itemId as NavigationRoutes);
  }, [navigate, route.itemId]);

  const style = React.useMemo(() => {
    if (activeKey === route.itemId) {
      return {
        backgrondColor: theme.colors.primaryLightest,
        color: theme.colors.primaryDefault,
      };
    }
    return {
      backgrondColor: 'transparent',
      color: theme.colors.inkDefault,
    };
  }, [activeKey, route.itemId, theme.colors]);

  if (typeof route.title === 'undefined') return null;
  if (typeof route.itemId === 'undefined') return null;

  return (
    <Link
      href={route.itemId}
      passHref
      style={{
        textDecoration: 'none',
      }}
    >
      <BeforeBorder
        className={`${depth === 1 ? '' : 'before-border'} ${
          activeKey === route.itemId ? 'before-border-active' : ''
        }`}
        onClick={_onChange}
        style={{ cursor: 'pointer' }}
        $style={{
          backgroundColor:
            activeKey === route.itemId ? theme.colors.bg1 : 'transparent',
        }}
      >
        <LinkContainer
          style={{ paddingLeft: `${depth === 1 ? '12px' : '20px'}` }}
          $style={{ display: 'flex', alignItems: 'center' }}
        >
          <>
            {route?.leftIcon?.(style.color, 18)}
            <StyledSpan $style={{ ...style, marginLeft: '8px' }}>
              {route.title}
            </StyledSpan>
          </>
        </LinkContainer>
      </BeforeBorder>
    </Link>
  );
}

const StyledSpan = themedStyled('span', {
  fontSize: '14px',
  lineHeight: '20px !important',
});
